module.exports = __webpack_public_path__ + "img/Boton_Tarjeta.7e5d556e.png";